import React from 'react';
import moment from 'moment';

function TarjetaInformeSimilar({ resultado, onSeleccionar, cargando }) {

    const valorNumero = (numero) => new Intl.NumberFormat().format(numero);

    const puntaje = Number(resultado.puntaje) || 0;
    const nivel = puntaje >= 75 ? 'alto' : puntaje >= 50 ? 'medio' : 'bajo';

    const fecha = resultado.fecha
        ? moment(resultado.fecha).format('DD/MM/YYYY')
        : '-';

    const equipo = [
        resultado.equipo?.nombre,
        resultado.equipo?.marca,
        resultado.equipo?.modelo
    ].filter(Boolean).join(' ');

    return (
        <button
            type="button"
            className="similar-tarjeta"
            onClick={() => onSeleccionar(resultado)}
            disabled={cargando}
        >
            <div className="similar-tarjeta__cabecera">
                <div>
                    <p className="similar-tarjeta__otin">OTIN {resultado.otin}</p>
                    <p className="similar-tarjeta__equipo">{equipo || '-'}</p>
                </div>
                <div className={`similar-badge similar-badge--${nivel}`}>
                    <span>{puntaje}%</span>
                    <div className="similar-badge__barra">
                        <div className="similar-badge__barra-lleno" style={{ width: `${Math.min(puntaje, 100)}%` }}></div>
                    </div>
                </div>
            </div>

            <p className="similar-tarjeta__falla">{resultado.falla || '-'}</p>

            {
                Array.isArray(resultado.motivos) && resultado.motivos.length > 0 ? (
                    <div className="similar-chips">
                        {resultado.motivos.map((motivo, index) => (
                            <span className="similar-chip" key={index}>{motivo}</span>
                        ))}
                    </div>
                ) : null
            }

            <div className="similar-tarjeta__meta">
                <span>{fecha}</span>
                <span>{resultado.tecnico || '-'}</span>
                <span>{resultado.cantidadItems ?? 0} ítems</span>
                <span>${valorNumero(resultado.totalCotizacion || 0)}</span>
            </div>
        </button>
    )
}

export default TarjetaInformeSimilar;
